import {useEffect, useState} from "react";

function useShowDownloadTemplate(auth) {

    const [isShowDownloadButton, setShowDownloadButton] = useState(false);

    useEffect(() => {
        let isMount = true;

            if ((auth?.roles[0] === 'CAPTAIN' && auth.user?.organization !== undefined)
                || (auth?.roles[0] === 'FORWARDER' && auth.user?.organization !== undefined)) {
                isMount && setShowDownloadButton(true)
            } else {
                isMount && setShowDownloadButton(false)
            }

        return () => {
            isMount = false;
        }
    },[auth])

    return {isShowDownloadButton};
}

export default useShowDownloadTemplate;
